import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { useTranslation } from '@/contexts/i18nContext';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('aether-cookie-consent');
    if (!consent) {
      // Small delay for smoother appearance
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('aether-cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const dismissBanner = () => {
    localStorage.setItem('aether-cookie-consent', 'dismissed');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-50 animate-slide-up">
      <div className="bg-background/95 backdrop-blur-xl border border-white/10 rounded-2xl p-4 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <p className="text-sm text-foreground/80 leading-relaxed">
              {t('cookies.message')}{' '}
              <Link 
                to="/privacy" 
                className="text-primary hover:text-primary/80 underline underline-offset-2 transition-colors"
              >
                {t('cookies.learnMore')}
              </Link>
            </p>
            <div className="flex items-center gap-2 mt-3">
              <button
                onClick={acceptCookies}
                className="px-4 py-1.5 text-xs font-medium bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
              >
                {t('cookies.accept')}
              </button>
              <button
                onClick={dismissBanner}
                className="px-4 py-1.5 text-xs font-medium text-foreground/60 hover:text-foreground transition-colors"
              >
                {t('cookies.dismiss')}
              </button>
            </div>
          </div>
          <button
            onClick={dismissBanner}
            className="p-1 text-foreground/40 hover:text-foreground/60 transition-colors shrink-0"
            aria-label={t('common.close')}
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
